export default __webpack_public_path__ + "static/media/6.21294a85.svg";